import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { COLOR_PRIMARY } from "../../styles/colors";
import TrafficPatternIcon from "../common/TrafficPatternIcon";
import { TrafficPatterns } from "../../models/traffic-patterns";
import { getCompactNumberStr } from "../../utils/iops-utils";

interface IOPSDisplayProps {
  totalIOPS: number;
  readPct: number;
  writePct: number;
  trafficPattern: TrafficPatterns | null;
  isMobile: boolean;
}

const IOPSDisplay: React.FC<IOPSDisplayProps> = ({
  totalIOPS,
  readPct,
  writePct,
  trafficPattern,
  isMobile,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: isMobile ? 1 : 2,
        color: COLOR_PRIMARY,
        border: `1px solid ${COLOR_PRIMARY}`,
        borderRadius: "8px",
        padding: isMobile ? "7px 6px" : "7px 10px",
        height: isMobile ? "28px" : "35px",
        flexGrow: 1,
      }}
    >
      {trafficPattern && (
        <TrafficPatternIcon pattern={trafficPattern} color="inherit" />
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: "bold",
            lineHeight: 1,
            marginBottom: "3px",
            fontSize: isMobile ? "0.7rem" : undefined,
          }}
        >
          Total TPS: {getCompactNumberStr(totalIOPS)}
        </Typography>
        <Typography
          variant="caption"
          sx={{ fontSize: isMobile ? "0.6rem" : "0.7rem", lineHeight: 1 }}
        >
          Read: {readPct}% Write: {writePct}%
        </Typography>
      </Box>
    </Box>
  );
};

export default IOPSDisplay;
